module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAKCAYAAAB4zEQNAAAAAXNSR0IArs4c6QAAAJZJREFUGBljYJDWCgXi1Qza2mwMaICJgeG/N8P//yEMH/6vZ1Bw4ECWZ2JIDU9iYGScD1TgxfD71WYGY2MuZAVAzf8ZgUZPZ5DS/M8grXkAaAUPSAEjiioprYlAlXlA0WMMnHyeQDsJARzGMjA0NDAB7ZsHsU9rN6qDpDUXQCW2onuFmYFPjBXoFUYGAcYwhtunfyK7AABezCliv9U4+AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right-angle.png
// module id = 431
// module chunks = 0